var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.763133 8.37336C3.05064 5.09439 6.01663 3.375 8.98802 3.375C12.4778 3.375 15.4839 5.64847 17.2575 8.38772L17.2583 8.38901C17.3757 8.57137 17.4381 8.78366 17.4381 9.00053C17.4381 9.217 17.3759 9.42891 17.259 9.61104C15.4869 12.3856 12.5002 14.625 8.98802 14.625C5.43841 14.625 2.50929 12.3902 0.741608 9.62379C0.621496 9.43728 0.559198 9.21941 0.562569 8.99757C0.565948 8.77518 0.635171 8.55879 0.76149 8.37573L0.763133 8.37336ZM1.68744 9.01467L1.689 9.0171C3.3217 11.5728 5.93854 13.5 8.98802 13.5C12.0033 13.5 14.6766 11.5646 16.3112 9.00487L16.3123 9.00319C16.3128 9.0024 16.3131 9.00147 16.3131 9.00053C16.3131 9.00013 16.3131 8.99974 16.313 8.99936C16.3128 8.99887 16.3127 8.9984 16.3124 8.99798C14.6715 6.46436 11.9764 4.5 8.98802 4.5C6.4799 4.5 3.82513 5.95167 1.68744 9.01467Z",
    fill: "#09984A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75ZM5.625 9C5.625 7.13604 7.13604 5.625 9 5.625C10.864 5.625 12.375 7.13604 12.375 9C12.375 10.864 10.864 12.375 9 12.375C7.13604 12.375 5.625 10.864 5.625 9Z",
    fill: "#09984A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.3735ee70f871682b945018d82923fa7e.svg";
export { ForwardRef as ReactComponent };